__turbopack_context__.v({
  "contactModal": "B2-Q4a_contactModal",
  "content": "B2-Q4a_content",
  "debounceProvider": "B2-Q4a_debounceProvider",
  "desktop": "B2-Q4a_desktop",
  "isAutoLogin": "B2-Q4a_isAutoLogin",
  "isAutoSave": "B2-Q4a_isAutoSave",
  "loginForm": "B2-Q4a_loginForm",
  "loginForm2": "B2-Q4a_loginForm2",
  "loginTroubleshootingModal": "B2-Q4a_loginTroubleshootingModal",
  "mobile": "B2-Q4a_mobile",
  "multiFactorAuthModal": "B2-Q4a_multiFactorAuthModal",
  "news__brlyr": "B2-Q4a_news__brlyr",
  "news__hQebs": "B2-Q4a_news__hQebs",
  "root": "B2-Q4a_root",
  "webFallbackRedirect": "B2-Q4a_webFallbackRedirect",
});
